<template>
  <div class="slideMenu">
    <Menu ref="side_menu" :active-name="getCheckMenu" accordion theme="light" width="auto" @on-select="changeNav">
        <MenuItem v-for="(item,index) in $store.state.menus" :key="index" :name="item.id" :to="item.url">
          <Icon :type="item.icon"></Icon>{{item.name}}
        </MenuItem>
    </Menu>
  </div>
</template>
<script>
import {mapGetters} from "vuex"
export default {
  data(){
    return{
      // $store.state.menus[getCheckMenu].id
    }
  },
  mounted(){
    // console.log(this.getCheckMenu);
    // console.log(this.$store.state.menus[0].id);
  },
  methods:{
    changeNav(name){
      console.log(name)
       this.$store.commit('setTags',name);
       this.$store.commit('setCheckMenu',name)
       console.log(this.$store.state.checkMenu);
       //state里sickName常见疾病不在开单页，则清空
       if(this.$store.state.checkMenu!=2){
         this.$store.state.sickName = '';
       }
    },
  },
  computed:{
    ...mapGetters(['getCheckMenu'])
  },
}
</script>

<style lang="less" scoped>
.slideMenu{
  
}
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.ivu-menu-vertical .ivu-menu-item{
  padding: 14px 24px 14px 45px;
}

</style>



// WEBPACK FOOTER //
// src/views/index/YnSlider.vue